/* Stadium guide (sections/tg-guide.liquid): marks the section in view in the rail and the phone jump links, and shows
   "sent" only on the contact form that was posted (Shopify flags every contact form; its redirect hash names the one used). */
(function () {
  var root = document.querySelector('[data-tgg]');
  if (!root) return;

  var posted = /contact_posted=true/.test(location.search);
  var hit = location.hash.slice(1);
  root.querySelectorAll('.tgg-form').forEach(function (f) {
    if (!posted || f.id !== hit) return;
    f.querySelector('.tgg-done').hidden = false;
    f.querySelector('.tgg-fields').hidden = true;
    var d = f.closest('details');
    if (d) d.open = true;
  });

  var links = root.querySelectorAll('[data-tgg-link]');
  var secs = Array.prototype.map.call(root.querySelectorAll('.tgg-sec[id]'), function (s) { return s; });
  if (!secs.length || !('IntersectionObserver' in window)) return;
  var chips = root.querySelector('.tgg-chips');
  /* v46 (DD §2): drop the right-edge fade once the chip row is scrolled to its end. */
  if (chips) {
    var endCheck = function () { chips.classList.toggle('is-end', chips.scrollLeft + chips.clientWidth >= chips.scrollWidth - 2); };
    chips.addEventListener('scroll', endCheck, { passive: true });
    window.addEventListener('resize', endCheck);
    endCheck();
  }
  function mark(id) {
    links.forEach(function (a) {
      var on = a.getAttribute('data-tgg-link') === id;
      a.setAttribute('aria-current', on ? 'true' : 'false');
      if (on && chips && chips.contains(a) && getComputedStyle(chips).display !== 'none') {
        chips.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });
      }
    });
  }
  var seen = {};
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { seen[e.target.id] = e.isIntersecting; });
    for (var i = 0; i < secs.length; i++) {
      if (seen[secs[i].id]) { mark(secs[i].id.replace('tgg-', '')); return; }
    }
  }, { rootMargin: '-20% 0px -60% 0px' });
  secs.forEach(function (s) { io.observe(s); });
})();

/* Pack for [city] (UI/UX 2026-10-28): a choice menu (gear row) or, since v34, a choose sheet's radio buttons (Pack band and
   "More for this lot") set their card's Add to cart; band cards also re-sum the section's "Add all" (v34: band cards only, the
   "More" row never counted). tailgater-add.js reads data-tg-add at click time, so updating the attribute is enough. */
document.addEventListener('change', function (e) {
  var sel = e.target.closest && e.target.closest('[data-tgg-pick], [data-tgg-pick-radio]');
  if (!sel) return;
  var box = sel.closest('.tgg-padd');
  var btn = box && box.querySelector('[data-tg-add]');
  if (btn) btn.setAttribute('data-tg-add', sel.value);
  var cents = sel.tagName === 'SELECT' ? (sel.options[sel.selectedIndex] || {}).getAttribute && sel.options[sel.selectedIndex].getAttribute('data-cents') : sel.getAttribute('data-cents');
  if (box && cents) box.setAttribute('data-cents', cents);
  var sec = sel.closest('#tgg-pack');
  var all = sec && box && box.closest('.tgg-band__card') && sec.querySelector('[data-tg-addall]');
  if (!all) return;
  var cards = sec.querySelectorAll('.tgg-band__card .tgg-padd');
  all.setAttribute('data-tg-add', Array.prototype.map.call(cards, function (p) { return p.querySelector('[data-tg-add]').getAttribute('data-tg-add'); }).join(','));
  /* v27: the label carries the sum ("Add all 3 · $507"); re-sum from the picked choices. */
  if (all.hasAttribute('data-tg-n')) {
    var sum = 0;
    Array.prototype.forEach.call(cards, function (p) { sum += +(p.getAttribute('data-cents') || 0); });
    var d = sum / 100, money = '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var lab = all.querySelector('[data-tg-label]') || all;
    lab.textContent = 'Add all ' + all.getAttribute('data-tg-n') + ' · ' + money;
    document.dispatchEvent(new CustomEvent('tg:packsum', { detail: money }));
  }
});

/* v34 choose sheet (guide-impulse spec §2): "Choose" opens the card's inline sheet and focuses the picked choice; Esc closes
   it and returns focus to "Choose". */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-tgg-choose]');
  if (!b) return;
  var sheet = document.getElementById(b.getAttribute('aria-controls'));
  if (!sheet) return;
  sheet.hidden = false;
  b.setAttribute('aria-expanded', 'true');
  var r = sheet.querySelector('input:checked') || sheet.querySelector('input');
  if (r) r.focus();
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var sheet = e.target.closest && e.target.closest('.tgg-sheet');
  if (!sheet) return;
  var b = document.querySelector('[aria-controls="' + sheet.id + '"]');
  sheet.hidden = true;
  if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
});

/* v34 arrives-by (spec §2.6): data-tgg-eta = handling days + 5 transit, in business days, counted from today in the shopper's
   own time zone. "Usually arrives by Tue, Nov 4". */
(function () {
  var els = document.querySelectorAll('[data-tgg-eta]');
  if (!els.length) return;
  els.forEach(function (el) {
    var n = parseInt(el.getAttribute('data-tgg-eta'), 10);
    if (!(n > 0)) return;
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    el.textContent = 'Usually arrives by ' + d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });
})();

/* v33 phone sticky bar "Pack this lot" (CRO guide-impulse spec §4). Shows below 750 px once the Pack band has scrolled
   away above; hides while the band, the capture band, the footer or the cart drawer is in view, or a field has focus.
   Its Add all clicks the band's Add all (one add path; the event says source=sticky). When the cart already holds every
   band item it reads "Packed ✓" and goes to checkout. */
(function () {
  var bar = document.querySelector('[data-tgg-stick]');
  var band = document.querySelector('[data-tgg-pack]');
  var all = band && band.querySelector('[data-tg-addall]');
  if (!bar || !all || !('IntersectionObserver' in window)) return;
  var guide = bar.getAttribute('data-guide');
  var txt = bar.querySelector('[data-tgg-stick-txt]'), add = bar.querySelector('[data-tgg-stick-add]');
  var label = txt.textContent, n = band.getAttribute('data-tgg-n');
  var vis = {}, above = false, reached = false, shown = false, packed = false;
  /* v47 d1 (CRO mobile proposal, CEO 11-03): the bar also shows from Quick answers on (phones read ~36% of a guide; the band
     sits at 49–56%). One sticky bar at a time: it hides while the band, the Pregame sheet bar or the capture band is in view. */
  var start = document.getElementById('tgg-faq') || root0();
  function root0() { return document.querySelector('.tgg-main > .tgg-sec'); }
  function checkStart() { var r = start && start.getBoundingClientRect(); var was = reached; reached = !!r && r.top < window.innerHeight * 0.5; if (was !== reached) update(); }
  var mq = window.matchMedia('(max-width: 749px)');
  function ev(name) { if (window.gtag) gtag('event', name, { guide: guide }); if (window.clarity) clarity('event', name); }
  function drawerOpen() { var d = document.querySelector('#cart-drawer dialog, cart-drawer-component dialog'); return !!(d && d.open); }
  function typing() { var a = document.activeElement; return !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)); }
  function update() {
    var on = mq.matches && (above || reached) && !vis.band && !vis.sheet && !vis.cap && !vis.foot && !drawerOpen() && !typing();
    bar.hidden = !on;
    document.documentElement.classList.toggle('tgg-stick-on', on);
    if (on && !shown) { shown = true; ev('sticky_bar_shown'); }
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var k = e.target === band ? 'band' : e.target.id === 'tgg-capture' ? 'cap' : e.target === sheet ? 'sheet' : 'foot';
      vis[k] = e.isIntersecting;
      if (k === 'band') above = !e.isIntersecting && e.boundingClientRect.top < 0;
    });
    update();
  });
  io.observe(band);
  var cap = document.getElementById('tgg-capture'); if (cap) io.observe(cap);
  var foot = document.querySelector('footer, .footer'); if (foot) io.observe(foot);
  var sheet = document.querySelector('.tgg-sbar'); if (sheet) io.observe(sheet);
  if (start) { window.addEventListener('scroll', checkStart, { passive: true }); checkStart(); }
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', function () { setTimeout(update, 0); });
  mq.addEventListener && mq.addEventListener('change', update);
  var dlg = document.querySelector('#cart-drawer dialog, cart-drawer-component dialog');
  /* The drawer can remove items too: re-read the cart each time it closes. */
  if (dlg) new MutationObserver(function () { update(); if (!dlg.open) refresh(); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

  function sync(cart) {
    var ids = (band.getAttribute('data-tgg-ids') || '').split(',');
    var have = (cart.items || []).map(function (it) { return String(it.variant_id); });
    packed = ids.length > 0 && ids.every(function (id) { return have.indexOf(id) > -1; });
    if (packed) {
      var d = cart.total_price / 100;
      txt.textContent = 'Packed ✓';
      add.textContent = 'Checkout $' + (d % 1 ? d.toFixed(2) : d.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      txt.textContent = label;
      add.textContent = 'Add all';
    }
  }
  document.addEventListener('tg:cart', function (e) { if (e.detail) sync(e.detail); });
  document.addEventListener('tg:packsum', function (e) { label = 'Pack this lot · ' + n + ' items · ' + e.detail; if (!packed) txt.textContent = label; });
  function refresh() { fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(sync).catch(function () {}); }
  refresh();

  bar.querySelector('[data-tgg-stick-go]').addEventListener('click', function () {
    ev('sticky_bar_tap');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    band.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  });
  add.addEventListener('click', function () {
    ev('sticky_bar_tap');
    if (packed) { window.location.href = '/checkout'; return; }
    all.setAttribute('data-tg-ev-x', 'source=sticky');
    all.click();
    all.setAttribute('data-tg-ev-x', 'source=band');
  });
})();

/* v34 (guide-impulse spec §3.5): on a guide the drawer gets "Keep reading" under Check out; it closes the drawer and leaves
   the reader where they were. Re-added whenever the drawer re-renders. */
(function () {
  if (!document.querySelector('[data-tgg]')) return;
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  function place() {
    var co = drawer.querySelector('.cart__checkout-button');
    if (!co || drawer.querySelector('.tgg-keep')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tgg-keep';
    b.textContent = 'Keep reading';
    b.addEventListener('click', function () { var x = drawer.querySelector('.theme-drawer__close-button, .cart-drawer__close-button'); if (x) x.click(); });
    co.insertAdjacentElement('afterend', b);
  }
  place();
  new MutationObserver(place).observe(drawer, { childList: true, subtree: true });
})();
